import { NextPlaylistContent } from '../../playlistContent/components/NextPlaylistContent';
import { HR } from 'foundations-components/transitional/components/HR';
import { getHumanizedDuration } from '../../../utils/utils';
import { View } from 'foundations-components/transitional/components/View';
import ACVerticalStepper from 'academy-common-lib/components/progress/ACVerticalStepper';
import { Text } from 'foundations-components/components/Text';
import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LearningPageSidebar from '../../../containers/TrackPage/LearningPageSidebar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortContentPlaylistNavigation = ({
  shortId,
  name,
  duration,
  status
}) => {
  const {
    isMobile
  } = useMediaQuery();
  if (isMobile) return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        title,
        subtitle,
        url
      }) => /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: false,
        helpText: subtitle,
        title: title,
        to: url
      }),
      shortId: shortId
    })]
  });
  return /*#__PURE__*/_jsxs(LearningPageSidebar, {
    id: "sidebarNavigator",
    withSubNav: 1,
    children: [/*#__PURE__*/_jsx(ACVerticalStepper, {
      activeStep: 0,
      iconOffset: "300",
      renderStep: step => /*#__PURE__*/_jsxs(View, {
        paddingBlock: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h6",
          children: step.title
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: getHumanizedDuration(step.duration)
        })]
      }),
      stepSpacing: {
        padding: '400'
      },
      steps: [{
        title: name,
        duration,
        complete: status === 'COMPLETED'
      }]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(NextPlaylistContent, {
      render: ({
        title,
        subtitle,
        url
      }) => /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: false,
        helpText: subtitle,
        title: title,
        to: url
      }),
      shortId: shortId
    })]
  });
};